import { render } from "./App.vue?vue&type=template&id=10d98954"
const script = {}

import "./App.vue?vue&type=style&index=0&id=10d98954&lang=css"

import exportComponent from "/home/trit/trit/dev/caspwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__